export default __webpack_public_path__ + "static/media/logo-completo.d67b6c31.png";